import { render, staticRenderFns } from "./imageLive.vue?vue&type=template&id=5b45bda8&scoped=true&"
import script from "./imageLive.vue?vue&type=script&lang=js&"
export * from "./imageLive.vue?vue&type=script&lang=js&"
import style0 from "./imageLive.vue?vue&type=style&index=0&id=5b45bda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b45bda8",
  null
  
)

export default component.exports